import { combineReducers } from 'redux';

import attentionPoints from './attentionPoints';
import dashboard from './dashboard';
import details from './details';

export default combineReducers({
  details,
  dashboard,
  attentionPoints,
});
